import { I18n } from "@assets/strings";
import React from "react";
import { ClipLoader } from "react-spinners";
import styled from "styled-components";
import { CourseStatus } from "@domain/lms/course/courseDraft";
import { useMyQuizzes } from "@domain/lms/quiz/hooks";
import { Secondary } from "@ui/components/containers/textBlocks";
import { InfiniteScroll } from "@ui/components/infiniteScroll";
import { QuizThumbnail } from "@ui/components/quiz/quizThumbnail";
import { desktop, gap, mobile } from "@ui/styles/utils";

interface MyQuizzesListProps extends React.HTMLAttributes<HTMLDivElement> {
	status: CourseStatus | "ALL";
}

export const MyQuizzesList: React.FC<MyQuizzesListProps> = ({ status, ...htmlProps }) => {
	const { result: quizzes, fetchMore, loading, moreLoading, totalElements } = useMyQuizzes(status);

	return (
		<Container>
			{totalElements === 0 ? (
				<Secondary>
					{I18n.t(status === "ALL" ? "profile.course_self.empty_all" : "profile.course_self.empty")}
				</Secondary>
			) : (
				<InfiniteScroll onEndReached={fetchMore} loading={loading || moreLoading}>
					<Quizzes {...htmlProps}>
						{quizzes.map((quiz) => (quiz ? <QuizThumbnail key={quiz.id} quiz={quiz} displayStatus /> : <></>))}
						{loading && <ClipLoader />}
					</Quizzes>
				</InfiniteScroll>
			)}
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

const Quizzes = styled.div`
	@media ${desktop} {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-gap: 20px;
	}
	@media ${mobile} {
		${gap(20)};
	}
`;
